import { useState } from "react";

/** Keep editing local; only publish the search value when Enter is pressed. */
export function EnterSearchInput({ value, onChange, onKeyDown, ...props }) {
  const [draft, setDraft] = useState(value ?? "");
  const [previousValue, setPreviousValue] = useState(value);

  // Synchronize explicit parent resets without discarding unsubmitted typing.
  if (value !== previousValue) {
    setPreviousValue(value);
    setDraft(value ?? "");
  }

  return (
    <input
      {...props}
      value={draft}
      enterKeyHint="search"
      onChange={(event) => setDraft(event.target.value)}
      onKeyDown={(event) => {
        if (event.key === "Enter" && !event.nativeEvent.isComposing && event.keyCode !== 229) {
          event.preventDefault();
          if (!event.repeat) onChange?.(event);
        }
        onKeyDown?.(event);
      }}
    />
  );
}